/* eslint-disable @reatom/unit-naming-rule */

import { atom } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { createCreatorPairsTableColumns } from '@root/features/services/creator-pairs/ui/creator-pairs-table/creator-pairs-table-columns'
import { reatomDataTable } from '@root/shared/ui-kit'

import { deployedTokensRequestAction } from './deployed-tokens-request-action'

import type { PairModel } from '@root/entities/pair'
import type { DelugeId } from '@root/entities/user-short'
import type { TableData } from '@root/shared/ui-kit'

export type CreatorPairsTableColumn =
  | 'pair'
  | 'createdAt'
  | 'migrated'
  | 'mcap'
  | 'liquidity'
  | 'holders'
  | 'pnl'
  | 'bondingCurveProgress'

export const reatomUserProfileDeployedTokensTable = (args: {
  delugeId: DelugeId
}) => {
  const paramsAtom = atom((ctx) => {
    return {
      network: ctx.spy(selectedNetworkAtom),
    }
  }, 'paramsAtom')

  const tableModel = reatomDataTable({
    columns: createCreatorPairsTableColumns(),
    getId: (it: PairModel) => it.address,
    paramsAtom,
    name: 'user-profile-deployed-tokens-table',
    loadItems: async (ctx, tableParams) => {
      const result = await deployedTokensRequestAction(ctx, {
        network: tableParams.params.network,
        delugeId: args.delugeId,
        period: '1H',
      })

      const mappedResult = result.pipe(
        Result.map((data) => {
          const tableData: TableData<PairModel> = {
            data: data,
            hasNext: false,
          }

          return tableData
        }),
      )

      return mappedResult
    },
  })

  return tableModel
}
export type UserProfileDeployedTokensTableModel = ReturnType<
  typeof reatomUserProfileDeployedTokensTable
>
